import { StateType } from 'data/types'
import { createSelector } from 'reselect'

import { LocalSettingsType } from '../types'

const DEFAULT_SETTINGS: LocalSettingsType = {
  orderFilledSound: true
}

export const getLocalSettings: (state: StateType) => LocalSettingsType = createSelector(
  (state) => state.auth,
  (auth) => auth.localSettings || DEFAULT_SETTINGS
)

export const getOrderFilledSoundSetting = createSelector(
  getLocalSettings,
  (settings: LocalSettingsType) => (settings ? settings.orderFilledSound : true)
)
